export default __webpack_public_path__ + "static/media/step6.bf3c1b85.webp";